<app-section-header title="{{ 'workOrderComments.title' | translate }}"></app-section-header>
<div class="container">
  <div class="main">
    <div class="comments">
      @if (getComments().length === 0) {
        <app-empty-list
          color="secondary"
          title="{{ 'workOrderComments.empty.title' | translate }}"
          info="{{ 'workOrderComments.empty.info' | translate }}"
        ></app-empty-list>
      }
      @for (comment of getComments(); track comment.id) {
        <div class="comment">
          @if (hasNotification(comment.id)) {
            <span class="update-notification"></span>
          }
          <app-comment [comment]="comment" [workOrder]="workOrder"> </app-comment>
        </div>
      }
    </div>
    <div class="side-bar">
      <div class="actions">
        <button mat-flat-button (click)="showAddNote()" color="primary">
          <i class="material-icons icon">message</i><span>{{ 'workOrderComments.list.addNote' | translate }}</span>
        </button>
      </div>

      @for (filter of getFilters(); track filter) {
        <div class="filter">
          <app-check-button
            [title]="getReferenceLabelWithCount(filter)"
            [info]="getReferenceTypeKey(filter) | translate"
            [checked]="filter.selected"
            (click)="toggleFilter(filter)"
          ></app-check-button>
        </div>
      }
    </div>
  </div>
</div>
